"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var collectFormData = function collectFormData(form) {
  var _form$querySelector, _form$querySelector2, _form$querySelector3;
  var dict = {};
  var itemsSeparator = '||';
  var noCookieFoundValue = 'no cookie found';

  // --- Cookie + Utility Functions ---
  var getCookie = function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  };
  var setValueFromCookie = function setValueFromCookie(fieldName, cookieName) {
    var val = getCookie(cookieName);
    if (val) dict[fieldName] = val;
  };

  // --- (1) Dataset values ---
  var datasetMap = {
    'last_activity_sf_campaign_id': form.dataset.activityCampaignId,
    'last_activity_interest': form.dataset.activityInterestProfile,
    'last_activity_type': form.dataset.activityType,
    'last_activity_detail': form.dataset.activitySubject,
    'advertising_conversion_level': form.dataset.conversionLevel || 'undefined'
  };
  Object.entries(datasetMap).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];
    if (val) dict[key] = val;
  });

  // --- (2) UTM values ---
  var values = [];
  var utmValues = getCookie('utm_values');
  if (utmValues) {
    values = utmValues.split(itemsSeparator);
  } else {
    var params = new URLSearchParams(window.location.search);
    params.forEach(function (value, key) {
      if (key.startsWith('utm_')) {
        values.push("".concat(key, "=").concat(value));
      }
    });
  }
  if (!values.length) {
    var url = window.location.href.toLowerCase();
    var ref = document.referrer.toLowerCase();
    var utm_medium = 'direct';
    var utm_source = 'direct';
    if (url.includes('gclid') || url.includes('msclkid') || url.includes('fbclid') || url.includes('gbraid') || url.includes('wbraid')) {
      utm_medium = 'paid';
    } else if (/(bing|yahoo|baidu|duckduckgo|ecosia|google)/.test(ref)) {
      utm_medium = 'organic search';
    } else if (ref) {
      utm_medium = 'referrer';
    }
    if (ref) {
      try {
        var refDomain = new URL(ref).hostname.replace(/^www\./, '');
        utm_source = refDomain;
      } catch (_unused) {
        utm_source = 'direct';
      }
    }
    values.push("utm_medium=".concat(utm_medium));
    values.push("utm_source=".concat(utm_source));
  }
  values.forEach(function (item) {
    var _item$split = item.split('='),
      _item$split2 = _slicedToArray(_item$split, 2),
      key = _item$split2[0],
      value = _item$split2[1];
    dict["last_activity_".concat(key)] = decodeURIComponent(value || '');
  });

  // --- (3) Session + Analytics values ---
  setValueFromCookie('session_landing_page', 'rws_lp');
  setValueFromCookie('number_pages_session', 'rws_pages');
  setValueFromCookie('browser_language', 'rws_browser_language');
  var _ga = getCookie('_ga');
  if (_ga) {
    dict['google_client_id'] = _ga.substring(6);
  }

  // --- (4) HubSpot ad values ---
  var hsvalues = getCookie('hs_values');
  var adFields = ['hsa_cam', 'hsa_grp', 'hsa_mt', 'hsa_src', 'hsa_ad', 'hsa_acc', 'hsa_net', 'hsa_kw', 'hss_channel'];
  if (hsvalues) {
    var pairs = hsvalues.split(itemsSeparator);
    var result = {};
    var _iterator = _createForOfIteratorHelper(pairs),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var pair = _step.value;
        var _pair$split = pair.split('='),
          _pair$split2 = _slicedToArray(_pair$split, 2),
          key = _pair$split2[0],
          value = _pair$split2[1];
        result[key] = value;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    dict['ad_hs_campaign'] = result['hsa_cam'];
    dict['ad_hs_group'] = result['hsa_grp'];
    dict['ad_hs_match_type'] = result['hsa_mt'];
    dict['ad_hs_source_network'] = result['hsa_src'];
    dict['ad_hs_creative'] = result['hsa_ad'];
    dict['ad_hs_account_id'] = result['hsa_acc'];
    dict['ad_hs_network'] = result['hsa_net'];
    dict['ad_hs_keyword'] = result['hsa_kw'];
    dict['social_hs_channel'] = result['hss_channel'];
  } else {
    adFields.forEach(function (field) {
      var cleanKey = field.replace('hsa_', 'ad_hs_');
      dict[cleanKey] = noCookieFoundValue;
    });
    dict['social_hs_channel'] = noCookieFoundValue;
  }

  // --- (5) Activity interest (child overrides parent) ---
  var lastActivityInterest = ((_form$querySelector = form.querySelector('[name^="interest_profile_child_"]')) === null || _form$querySelector === void 0 ? void 0 : _form$querySelector.value) || ((_form$querySelector2 = form.querySelector('[name="last_activity_interest"]')) === null || _form$querySelector2 === void 0 ? void 0 : _form$querySelector2.value) || ((_form$querySelector3 = form.querySelector('[name="parent_interest_profile"]')) === null || _form$querySelector3 === void 0 ? void 0 : _form$querySelector3.value);
  if (lastActivityInterest) dict['last_activity_interest'] = lastActivityInterest;
  return dict;
};
var fixFormAccessibility = function fixFormAccessibility(form) {
  var lis = form.querySelectorAll('[class="hs-form-checkbox"], [class="hs-form-radio"], [class="inputs-list multi-container"]');
  if (lis && lis.length > 0) {
    lis.forEach(function (li) {
      li.removeAttribute('role');
    });
  }
  var hsFileds = form.querySelectorAll('[type="checkbox"], [type="radio"]');
  if (hsFileds && hsFileds.length > 0) {
    hsFileds.forEach(function (field) {
      var parent = field.parentNode;
      if (parent) {
        var labelId = 'label-for-' + field.getAttribute('id');
        parent.setAttribute('id', labelId);
        field.setAttribute('aria-labelledby', labelId);
      }
    });
  }
};
var _initLabels = function initLabels(form) {
  var hsFields = form.querySelectorAll('input.hs-input:not(.hs-field-ready):not([type="hidden"]):not([type="checkbox"]):not([type="radio"]), select.hs-input:not(.hs-field-ready), textarea.hs-input:not(.hs-field-ready)');
  hsFields && hsFields.forEach(function (field) {
    var fieldOuter = field.closest('.field.hs-form-field');
    var fieldLabel = fieldOuter.querySelector(':scope > label span');
    var fieldLabelNode = fieldOuter.querySelector(':scope > label');
    var fieldInput = fieldOuter.querySelector(':scope > .input');
    if (fieldLabel === null) return;
    if (fieldLabel.innerText === '') {
      var placeholderText = field.getAttribute('placeholder');
      var selectText = field.querySelector('option[disabled]');
      fieldLabel.innerText = placeholderText || (selectText === null || selectText === void 0 ? void 0 : selectText.innerText);
    }
    field.onblur = function () {
      fieldOuter.classList.remove('focused');
      !field.value && fieldOuter.classList.remove('active');
    };
    field.onfocus = function () {
      return fieldOuter.classList.add('active', 'focused');
    };
    if (fieldOuter.classList.contains('hs-fieldtype-select')) {
      field.onchange = function () {
        setTimeout(function () {
          return _initLabels(form);
        }, 400);
      };
    }
    fieldLabelNode.setAttribute('placeholder', fieldLabel.innerText || '');
    fieldInput.prepend(fieldLabelNode);
    field.classList.add('hs-field-ready');
    !!field.value && fieldOuter.classList.add('active');
  });
};
var initLabelsMulti = function initLabelsMulti(form) {
  var rejectTypes = ':not(.hs-field-ready, .hsfc-DateInput, [type="tel"], [type="hidden"], [type="checkbox"], [type="radio"], [role="searchbox"])';
  var errorSelector = '.hsfc-ErrorAlert';
  var hsFields = form.querySelectorAll('input.hsfc-TextInput' + rejectTypes + ', textarea.hsfc-TextareaInput' + rejectTypes);
  hsFields && hsFields.forEach(function (field) {
    var fieldOuter = field.closest('.hsfc-Row');
    var fieldInput = field.classList.contains('hsfc-TextInput--button') ? fieldOuter.querySelector(':scope > [class*="Field"]') : field.parentNode;
    var fieldLabelNode = fieldInput.querySelector(':scope > label');
    var fieldLabel = fieldLabelNode === null || fieldLabelNode === void 0 ? void 0 : fieldLabelNode.querySelector('span');
    if (!fieldLabel) return;
    if (!fieldLabel.innerText) {
      var placeholderText = field.getAttribute('placeholder');
      var selectText = field.querySelector('option[disabled]');
      fieldLabel.innerText = placeholderText || (selectText === null || selectText === void 0 ? void 0 : selectText.innerText) || '';
    }
    var updateErrorState = function updateErrorState() {
      return setTimeout(function () {
        var error = fieldInput.querySelector(errorSelector);
        fieldInput.classList.toggle('invalid', !!error);
      }, 100);
    };
    field.onblur = function () {
      fieldInput.classList.remove('focused');
      !field.value && fieldInput.classList.remove('active');
      updateErrorState();
    };
    field.onfocus = function () {
      fieldInput.classList.add('active', 'focused');
      updateErrorState();
    };
    fieldLabelNode.setAttribute('placeholder', fieldLabel.innerText || '');
    field.classList.add('hs-field-ready');
    !!field.value && fieldOuter.classList.add('active');
  });
};
var hideElement = function hideElement(selector) {
  var element = typeof selector == 'string' ? document.querySelector(selector) : selector;
  if (element) {
    element.style.display = 'none';
  }
};
var setFormFilled = function setFormFilled(formId) {
  var cookieName = '_rws_resources_forms';
  var value = getCookie(cookieName);
  value = value ? value += "|".concat(formId) : formId;
  setCookie(cookieName, value, 7);
};
var initHubSpotForm = function initHubSpotForm(formEl, dataDict) {
  var formObj = {
    portalId: formEl.dataset.portalId,
    formId: formEl.dataset.formId,
    target: "#".concat(formEl.id),
    onFormReady: function onFormReady($form) {
      // Fill in the form with collected data
      for (var _i = 0, _Object$entries = Object.entries(dataDict); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          val = _Object$entries$_i[1];
        var field = formEl[key] || formEl.querySelector("[name=\"".concat(key, "\"]"));
        if (field && field.type === 'hidden') {
          field.value = val !== null && val !== void 0 ? val : '';
        }
      }

      // Some old UI code, haven't changed it at all
      fixFormAccessibility($form);
      _initLabels($form);

      // Debug if enabled (all env except prod live)
      if (window.debugHubspotForms) {
        debugHubspotForm(formEl, formEl, dataDict);
      }
    },
    onFormSubmit: function onFormSubmit($form) {
      var _$form$last_activity_, _$form$parent_interes, _$form$advertising_co, _$form$which_of_the_f;
      var lastActivityInterest = ($form === null || $form === void 0 || (_$form$last_activity_ = $form.last_activity_interest) === null || _$form$last_activity_ === void 0 ? void 0 : _$form$last_activity_.value) || ($form === null || $form === void 0 || (_$form$parent_interes = $form.parent_interest_profile) === null || _$form$parent_interes === void 0 ? void 0 : _$form$parent_interes.value) || undefined;
      var childActivityInterest = document.querySelector('[name^="interest_profile_child_"]');
      if (childActivityInterest) {
        lastActivityInterest = childActivityInterest.value || undefined;
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'hubspot-form-success',
        'hs-form-guid': formEl.dataset.formId,
        'hs-activity-type': formEl.dataset.activityType || undefined,
        'hs-activity-subject': formEl.dataset.activitySubject || undefined,
        'hs-activity-campaignId': formEl.dataset.activityCampaignId || undefined,
        'hs-activity-interest-profile': formEl.dataset.activityInterestProfile || undefined,
        'conversion_level': ($form === null || $form === void 0 || (_$form$advertising_co = $form.advertising_conversion_level) === null || _$form$advertising_co === void 0 ? void 0 : _$form$advertising_co.value) || undefined,
        'hs-activity-record-type': ($form === null || $form === void 0 || (_$form$which_of_the_f = $form.which_of_the_following_best_describes_you__) === null || _$form$which_of_the_f === void 0 ? void 0 : _$form$which_of_the_f.value) || undefined,
        'primary-area-interest': lastActivityInterest
      });
      var email = null;
      var formData = new FormData($form);
      var _iterator2 = _createForOfIteratorHelper(formData),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 2),
            name = _step2$value[0],
            value = _step2$value[1];
          if (name === 'email') {
            email = value;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      typeof clearbit !== 'undefined' && email && clearbit.identify(email, {
        email: email
      });
      var isVideoContent = document.querySelector('.resource__form_inner .resource__form__video__play') != null;
      var relatedContent = document.querySelector('.related_content--hidden');
      if (relatedContent && !isVideoContent) {
        relatedContent.classList.remove('related_content--hidden');
      }
    }
  };
  if (formEl.dataset.thankYouPageUrl && formEl.dataset.externalPageUrl === '') {
    formObj.redirectUrl = formEl.dataset.thankYouPageUrl;
  } else {
    formObj.inlineMessage = formEl.dataset.thankYouMessage;
  }
  formObj.onFormSubmitted = function ($form, data) {
    if (formEl.dataset.onFormSubmitted != null) {
      eval(formEl.dataset.onFormSubmitted);
    }
    setFormFilled(formEl.dataset.formId);
    hideElement('.resource__form__description');

    // Trados form logic
    var urlSelector = data.submissionValues['which_of_the_following_best_describes_you___trados_trial_'];
    if (urlSelector) {
      var utmObj = getUtmObject(true);
      var groups = getOptanonGroups();
      var _formObj = {
        firstName: data.submissionValues['firstname'],
        lastName: data.submissionValues['lastname'],
        email: data.submissionValues['email'],
        company: data.submissionValues['company'],
        jobTitle: data.submissionValues['jobtitle'],
        country: data.submissionValues['country__code____trados'],
        accountType: data.submissionValues['which_of_the_following_best_describes_you___trados_trial_'],
        region: data.submissionValues['region__trados_trial_'],
        returnUrl: window.location.href
      };
      if (data.submissionValues['vendor_code']) {
        _formObj.vendorCode = data.submissionValues['vendor_code'];
      }
      var qsObject = _objectSpread(_objectSpread(_objectSpread({}, _formObj), utmObj), groups);
      var queryString = new URLSearchParams(qsObject).toString();
      window.location.href = formEl.dataset.externalPageUrl + (formEl.dataset.externalPageUrl.includes('?') ? '&' : '?') + queryString;
    }
    if (formEl.dataset.postBackOnSubmit === 'True') {
      hideElement(formEl);
      var frm = document.createElement('form');
      frm.method = 'POST';
      frm.action = formEl.dataset.thankYouPageUrl || window.location.href;
      document.body.appendChild(frm);
      frm.submit();
    }

    // Resource download
    if (formEl.dataset.resourceUrl) {
      var isIOS = /iPad|iPhone|iPod|Firefox/.test(navigator.userAgent) && !window.MSStream || navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2;
      var isMac = navigator.appVersion.indexOf('Mac') != -1;
      var f = document.createElement('form');
      document.body.appendChild(f);
      f.style = 'display: none';
      f.action = formEl.dataset.resourceUrl;
      f.method = 'POST';
      f.target = isIOS || isMac ? '_self' : '_blank';
      f.submit();
      document.body.removeChild(f);
    }
  };
  if (formEl.dataset.submitText) {
    formObj.submitText = formEl.dataset.submitText;
  }
  if (typeof hbspt != 'undefined') {
    hbspt.forms.create(formObj);
  }
  var observer = new MutationObserver(function (mutationsList) {
    var _iterator3 = _createForOfIteratorHelper(mutationsList),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var mutation = _step3.value;
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === Node.ELEMENT_NODE) {
              if (node.tagName === 'DIV') {
                fixFormAccessibility(formEl);
                _initLabels(formEl);
              }
            }
          });
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  });
  var config = {
    childList: true,
    subtree: true
  };
  observer.observe(formEl, config);
};
(function () {
  var selector = '.hubspot_form__body';
  var forms = document.querySelectorAll(selector);
  //init original hubspot forms
  forms && forms.forEach(function (form) {
    var formType = form.dataset.formType;
    if (formType && formType == "HubSpot") {
      var dataDict = collectFormData(form);
      initHubSpotForm(form, dataDict);
    }
  });
})();
var debugHubspotForm = function debugHubspotForm(formEl, hsform, dataDict) {
  console.groupCollapsed("\uD83E\uDDE9 HubSpot Form Debug [".concat(formEl.dataset.formId || formEl.id, "]"));

  // Show basic info
  console.log('Form:', formEl);
  console.log('hsform:', hsform);

  // (1) Enumerate all fields found in hsform
  var fields = [];
  var elements = hsform.querySelectorAll ? hsform.querySelectorAll('input, select, textarea') : Object.values(hsform).filter(function (f) {
    return f === null || f === void 0 ? void 0 : f.tagName;
  });
  elements.forEach(function (el) {
    fields.push({
      name: el.name || '(no name)',
      type: el.type || '(unknown)',
      value: el.value || '',
      hidden: el.type === 'hidden'
    });
  });
  console.groupCollapsed('📋 Form Fields');
  console.table(fields);
  console.groupEnd();

  // (2) Compare dictionary vs form fields
  if (dataDict) {
    var comparison = [];
    var _loop = function _loop() {
      var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
        key = _Object$entries2$_i[0],
        val = _Object$entries2$_i[1];
      var field = elements ? Array.from(elements).find(function (e) {
        return e.name === key;
      }) : hsform[key];
      comparison.push({
        field: key,
        dictionaryValue: val,
        formValue: field ? field.value : '(field not found)',
        applied: field ? '✅' : '❌'
      });
    };
    for (var _i2 = 0, _Object$entries2 = Object.entries(dataDict); _i2 < _Object$entries2.length; _i2++) {
      _loop();
    }
    console.groupCollapsed('🔍 Dictionary vs Form Mapping');
    console.table(comparison);
    console.groupEnd();
  }

  // (3) Log dataLayer snapshot if exists
  if (window.dataLayer && Array.isArray(window.dataLayer)) {
    console.groupCollapsed('📦 dataLayer Snapshot');
    console.table(window.dataLayer);
    console.groupEnd();
  }
  console.groupEnd();
};

///-----------------
/// v4 Forms Code
///-----------------

var pickValue = function pickValue(values, internalName) {
  // v4 field names look like "0-1/firstname". We match by exact or suffix.
  var row = values.find(function (v) {
    return v.name === internalName || v.name.endsWith('/' + internalName);
  });
  var val = row === null || row === void 0 ? void 0 : row.value;
  return Array.isArray(val) ? val[0] : val !== null && val !== void 0 ? val : '';
};
var readSubmissionDict = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(formInstance) {
    var values;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return formInstance.getFormFieldValues();
        case 1:
          values = _context.v;
          return _context.a(2, {
            get: function get(name) {
              return pickValue(values, name);
            },
            raw: values
          });
      }
    }, _callee);
  }));
  return function readSubmissionDict(_x) {
    return _ref3.apply(this, arguments);
  };
}();

//--- Populate form on READY ---
window.addEventListener('hs-form-event:on-ready', /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(event) {
    var formInstance, formId, formEl, observer, fields, dataDict, values, existing, bySuffix, _i3, _Object$entries3, _Object$entries3$_i, k, v, real;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          formInstance = HubSpotFormsV4.getFormFromEvent(event); // v4 instance
          formId = formInstance.getFormId();
          formEl = document.querySelector("[data-form-id=\"".concat(formId, "\"]"));
          if (formEl) {
            _context2.n = 1;
            break;
          }
          return _context2.a(2);
        case 1:
          initLabelsMulti(formEl);
          observer = new MutationObserver(function () {
            initLabelsMulti(formEl);
          });
          observer.observe(formEl, {
            childList: true,
            subtree: true
          });

          // 🧠 Wait until form actually has fields
          _context2.n = 2;
          return formInstance.getFormFieldValues();
        case 2:
          fields = _context2.v;
          if (!(!fields || !fields.length)) {
            _context2.n = 3;
            break;
          }
          if (window.debugHubspotForms) {
            console.info('HS v4 ready fired', formId, fields && fields.length ? "Fields found ".concat(fields.length) : 'No fields found');
          }
          return _context2.a(2);
        case 3:
          // Populate hidden fields as soon as the form is ready/rendered
          dataDict = collectFormData(formEl);
          _context2.n = 4;
          return formInstance.getFormFieldValues();
        case 4:
          values = _context2.v;
          existing = new Set(values.map(function (v) {
            return v.name;
          }));
          bySuffix = new Map(values.map(function (v) {
            return [v.name.split('/').pop(), v.name];
          }));
          _i3 = 0, _Object$entries3 = Object.entries(dataDict);
        case 5:
          if (!(_i3 < _Object$entries3.length)) {
            _context2.n = 7;
            break;
          }
          _Object$entries3$_i = _slicedToArray(_Object$entries3[_i3], 2), k = _Object$entries3$_i[0], v = _Object$entries3$_i[1];
          real = existing.has(k) ? k : bySuffix.get(k);
          if (!real) {
            _context2.n = 6;
            break;
          }
          _context2.n = 6;
          return formInstance.setFieldValue(real, String(v !== null && v !== void 0 ? v : ''));
        case 6:
          _i3++;
          _context2.n = 5;
          break;
        case 7:
          if (!window.debugHubspotForms) {
            _context2.n = 8;
            break;
          }
          _context2.n = 8;
          return debugHubspotFormV4(formInstance, dataDict);
        case 8:
          return _context2.a(2);
      }
    }, _callee2);
  }));
  return function (_x2) {
    return _ref4.apply(this, arguments);
  };
}());

//--- On submit SUCCESS ---
window.addEventListener('hs-form-event:on-submission:success', /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(event) {
    var formInstance, formId, formEl, sub, lastActivityInterest, childActivityInterestEl, email, isVideoContent, relatedContent, urlSelector, utmObj, groups, formObj, vendor, qs, base, frm, ua, isIOS, isMac, f, rtext;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          formInstance = HubSpotFormsV4.getFormFromEvent(event);
          formId = formInstance.getFormId();
          formEl = document.querySelector("[data-form-id=\"".concat(formId, "\"]"));
          if (formEl) {
            _context3.n = 1;
            break;
          }
          return _context3.a(2);
        case 1:
          if (formEl.dataset.onFormSubmitted != null) {
            try {
              eval(formEl.dataset.onFormSubmitted);
            } catch (e) {
              console.warn(e);
            }
          }
          if (typeof setFormFilled === 'function') setFormFilled(formEl.dataset.formId);
          if (typeof hideElement === 'function') hideElement('.resource__form__description');

          // Read submitted values (v4 way)
          _context3.n = 2;
          return readSubmissionDict(formInstance);
        case 2:
          sub = _context3.v;
          // --- Primary/child interest resolution (v4)
          lastActivityInterest = sub.get('last_activity_interest') || sub.get('parent_interest_profile') || undefined; // Child interest is on page DOM, so we can still read it directly
          childActivityInterestEl = document.querySelector('[name^="interest_profile_child_"]');
          if (childActivityInterestEl) {
            sub.get('last_activity_interest') || sub.get('parent_interest_profile');
            lastActivityInterest = childActivityInterestEl.value || undefined;
          }

          // --- dataLayer push
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'hubspot-form-success',
            'hs-form-guid': formEl.dataset.formId,
            'hs-activity-type': formEl.dataset.activityType || undefined,
            'hs-activity-subject': formEl.dataset.activitySubject || undefined,
            'hs-activity-campaignId': formEl.dataset.activityCampaignId || undefined,
            'hs-activity-interest-profile': formEl.dataset.activityInterestProfile || undefined,
            'conversion_level': sub.get('advertising_conversion_level') || undefined,
            'hs-activity-record-type': sub.get('which_of_the_following_best_describes_you__') || undefined,
            'primary-area-interest': lastActivityInterest
          });

          // --- Clearbit identify by submitted email
          email = sub.get('email') || null;
          if (typeof clearbit !== 'undefined' && email) {
            try {
              clearbit.identify(email, {
                email: email
              });
            } catch (e) {
              if (window.debugHubspotForms) console.warn('Clearbit identify failed:', e);
            }
          }

          // --- Related content if not a video form
          isVideoContent = document.querySelector('.resource__form_inner .resource__form__video__play') != null;
          relatedContent = document.querySelector('.related_content--hidden');
          if (relatedContent && !isVideoContent) {
            relatedContent.classList.remove('related_content--hidden');
          }

          // Trados form logic
          urlSelector = sub.get('which_of_the_following_best_describes_you___trados_trial_');
          if (!urlSelector) {
            _context3.n = 3;
            break;
          }
          utmObj = typeof getUtmObject === 'function' ? getUtmObject(true) : {};
          groups = typeof getOptanonGroups === 'function' ? getOptanonGroups() : {};
          formObj = {
            firstName: sub.get('firstname'),
            lastName: sub.get('lastname'),
            email: sub.get('email'),
            company: sub.get('company'),
            jobTitle: sub.get('jobtitle'),
            country: sub.get('country__code____trados'),
            accountType: sub.get('which_of_the_following_best_describes_you___trados_trial_'),
            region: sub.get('region__trados_trial_'),
            returnUrl: window.location.href
          };
          vendor = sub.get('vendor_code');
          if (vendor) {
            formObj.vendorCode = vendor;
          }
          qs = new URLSearchParams(_objectSpread(_objectSpread(_objectSpread({}, formObj), utmObj), groups)).toString();
          base = formEl.dataset.externalPageUrl || '';
          if (!base) {
            _context3.n = 3;
            break;
          }
          window.location.href = base + (base.includes('?') ? '&' : '?') + qs;
          return _context3.a(2);
        case 3:
          // POST back after submit
          if (formEl.dataset.postBackOnSubmit === 'True') {
            if (typeof hideElement === 'function') hideElement(formEl);
            frm = document.createElement('form');
            frm.method = 'POST';
            frm.action = formEl.dataset.thankYouPageUrl || window.location.href;
            document.body.appendChild(frm);
            frm.submit();
          }

          // Resource download POST
          if (formEl.dataset.resourceUrl) {
            ua = navigator.userAgent;
            isIOS = /iPad|iPhone|iPod|Firefox/.test(ua) && !window.MSStream || ua.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2;
            isMac = navigator.appVersion.indexOf('Mac') !== -1;
            f = document.createElement('form');
            document.body.appendChild(f);
            f.style = 'display:none';
            f.action = formEl.dataset.resourceUrl;
            f.method = 'POST';
            f.target = isIOS || isMac ? '_self' : '_blank';
            f.submit();
            document.body.removeChild(f);
          }

          // Redirect is set
          if (formEl.dataset.thankYouPageUrl && formEl.dataset.externalPageUrl === '') {
            window.location.href = formEl.dataset.thankYouPageUrl;
          }
          if (formEl.dataset.thankYouMessage && formEl.dataset.thankYouMessage != '') {
            rtext = formEl.querySelector('[data-hsfc-id="RichText"]');
            if (rtext) {
              rtext.innerHTML = formEl.dataset.thankYouMessage;
            }
          }
        case 4:
          return _context3.a(2);
      }
    }, _callee3);
  }));
  return function (_x3) {
    return _ref5.apply(this, arguments);
  };
}());
window.addEventListener('hs-form-event:on-submission:failed', /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(event) {
    var formInstance, formId, _event$detail, err, values;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          formInstance = HubSpotFormsV4.getFormFromEvent(event);
          formId = formInstance.getFormId();
          console.error('❌ HS v4 submission failed', formId, event);
          if (!window.debugHubspotForms) {
            _context4.n = 2;
            break;
          }
          console.groupCollapsed("\u274C Submission failed [".concat(formId, "]"));
          console.log('Raw event:', event);

          // Log error
          err = ((_event$detail = event.detail) === null || _event$detail === void 0 ? void 0 : _event$detail.error) || event.detail || event.message || {};
          console.log('Error detail:', err);

          // inspect HubSpot field values
          _context4.n = 1;
          return formInstance.getFormFieldValues();
        case 1:
          values = _context4.v;
          console.table(values.map(function (v) {
            return {
              name: v.name,
              value: Array.isArray(v.value) ? v.value.join(',') : v.value
            };
          }));
          console.groupEnd();
        case 2:
          return _context4.a(2);
      }
    }, _callee4);
  }));
  return function (_x4) {
    return _ref6.apply(this, arguments);
  };
}());
var debugHubspotFormV4 = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(formInstance, dataDict) {
    var values, map, bySuffix, rows;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          _context5.n = 1;
          return formInstance.getFormFieldValues();
        case 1:
          values = _context5.v;
          // Log the form’s field table
          console.groupCollapsed("\uD83E\uDDE9 HS v4 Debug [".concat(formInstance.getFormId(), "]"));
          console.table(values.map(function (v) {
            return {
              name: v.name,
              value: Array.isArray(v.value) ? v.value.join(',') : v.value
            };
          }));

          // Compare your dictionary to what the instance has
          if (dataDict) {
            map = new Map(values.map(function (v) {
              return [v.name, v.value];
            }));
            bySuffix = new Map(values.map(function (v) {
              return [v.name.split('/').pop(), v.name];
            })); // allow plain names
            rows = Object.entries(dataDict).map(function (_ref8) {
              var _ref9 = _slicedToArray(_ref8, 2),
                k = _ref9[0],
                v = _ref9[1];
              var real = map.has(k) ? k : bySuffix.get(k);
              return {
                field: k,
                dictionaryValue: v,
                matchedField: real !== null && real !== void 0 ? real : '(field not found)',
                formValue: real ? map.get(real) : '(n/a)',
                applied: !!real ? '✅' : '❌'
              };
            });
            console.groupCollapsed('🔍 Dictionary vs Form (v4)');
            console.table(rows);
            console.groupEnd();
          }
          console.groupEnd();
        case 2:
          return _context5.a(2);
      }
    }, _callee5);
  }));
  return function debugHubspotFormV4(_x5, _x6) {
    return _ref7.apply(this, arguments);
  };
}();